import * as yup from 'yup';

export const metricCreate = yup.object().shape({
  name: yup.string().required().min(1).label("Can't be empty"),
  value: yup.string(),
  description: yup.string(),
  groups_ids: yup.array().of(yup.number()),
});
